// @ts-nocheck
import Button from 'atoms/button/button';
import DatePicker from 'atoms/datePicker/datePicker';
import Divider from 'atoms/divider/divider';
import Dropdown from 'atoms/dropdown/dropdown';
import MultiSelectDropdown from '../../../atoms/dropdown/multiSelectDropdown';
import Label from 'atoms/label/label';
import Loader from 'atoms/loader';
import Sheet from 'atoms/sheet/sheet';
import SheetBody from 'atoms/sheet/sheetBody/sheetBody';
import TextInput from 'atoms/TextInput/textInput';
import Validation from 'atoms/validation/validation';
import OrderValidation from 'atoms/validation/orderInfoValidation';
import _ from 'lodash';
import Stack from 'molecules/stack/stack';
import StackItem from 'molecules/stackItem/stackItem';
import moment from 'moment';
import * as generateOrderActions from './sagaActions';
import * as generateOrderSelectors from './selectors';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as query from './query';
import ParameterDetailItem from './parameterDetailItem';
import PlanogramDetails from './planogramDetails';
import { Typography, Col, Row } from 'antd';
import { getState } from 'reducers';
import { getColumnInfoByIndentifier } from 'models/tableColumns/selector';
import * as constants from './constants';
import { useColumnAliasName } from 'hooks/useColumnAliasName';
import { getUserInfo } from 'models/user/selector';

type TProps = {
	hideModal: React.MouseEventHandler;
	handleNextClick: React.MouseEventHandler;
};

const { Text, Title } = Typography;

const OrderInfo = (props: TProps) => {
	const { hideModal, handleNextClick } = props;
	const dispatch = useDispatch();
	const data = useSelector((state) => generateOrderSelectors.getData(state));
	const [customerTouched, setCustomerTouched] = useState(false);
	const userInfo = useSelector<any, UserInfo>(getUserInfo);

	const currentTenent = userInfo.allTenentList?.find((t) => t.PartnerID === userInfo.grpId);

	const getCustomerOptions = useSelector((state) => generateOrderSelectors.getCustomerOptions(state));

	const customerOptions = React.useMemo(() => {
		return [{ displayName: 'All', value: '-1' }, ...getCustomerOptions];
	}, [getCustomerOptions]);
	const [updatedOptions, setUpdatedOptions] = useState([]);

	const shippingMethodOptions = useSelector((state) => generateOrderSelectors.getShippingMethodsOptions(state));

	const warehouseOptions = useSelector((state) => generateOrderSelectors.getWarehouseOptions(state));

	const storeScheduleOptions = useSelector((state) => generateOrderSelectors.getStoreScheduleOptions(state));

	const modalLoading = useSelector((state) => generateOrderSelectors.isLoading(state, 'loadModal'));

	const getColumnAliasName = useColumnAliasName(constants.UPLOAD_MODEL_ID);
	const today = moment().format('MM-DD-YYYY');
	const validateFormData = React.useCallback((): boolean => {
		return query.validateForm(data);
	}, [data]);
	const parametersList = useSelector(generateOrderSelectors.getParameterList);

	const inputChangeHandler = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		let value = e?.target?.type === 'checkbox' ? e.target.checked : e.target?.value;
		if (e.target.name === 'isKitOrder' && value) {
			dispatch(
				generateOrderActions.updateModalData({
					isKitOrder: value,
					usePlanogram: false,
				})
			);
			return;
		} else if (e.target.name === 'usePlanogram' && value) {
			dispatch(
				generateOrderActions.updateModalData({
					isKitOrder: false,
					usePlanogram: value,
				})
			);
			return;
		} else if (e.target.type === 'date' && value === '') {
			value = null;
		}
		dispatch(
			generateOrderActions.updateModalData({
				[e.target.name]: value,
			})
		);
	}, []);

	const handleCustomerBlur = useCallback(() => {
		setCustomerTouched(true);
	}, []);

	const customerChangeHandler = React.useCallback(
		(item: any) => {
			setCustomerTouched(true);
			if (item?.includes('-1') && !data.customerID?.includes('-1')) {
				dispatch(
					generateOrderActions.updateModalData({
						customerID: ['-1'],
					})
				);
				return;
			}
			if (data?.customerID?.includes('-1')) {
				dispatch(
					generateOrderActions.updateModalData({
						customerID: _.filter(item, (value) => Number(value) > 0),
					})
				);
				return;
			}
			dispatch(
				generateOrderActions.updateModalData({
					customerID: item,
				})
			);
		},
		[data]
	);

	const shipMethodChangeHandler = React.useCallback((item: any) => {
		dispatch(
			generateOrderActions.updateModalData({
				shipMethodID: item.value,
			})
		);
	}, []);

	const warehouseChangeHandler = React.useCallback((item: any) => {
		dispatch(
			generateOrderActions.updateModalData({
				warehouseID: item.value,
			})
		);
	}, []);

	const storeScheduleChangeHandler = React.useCallback((item: any) => {
		dispatch(
			generateOrderActions.updateModalData({
				storeScheduleID: item.value,
			})
		);
	}, []);

	const username = currentTenent?.UserName;
	const isSandboxUser = username ? /\bSandbox\b/i.test(username) : false;
	const minShipStartDate = isSandboxUser ? undefined : today;

	if (modalLoading) {
		return (
			<Sheet isTab>
				<SheetBody>
					<Stack isVertical>
						<StackItem isGrow isStretch align="center">
							<Loader />
						</StackItem>
					</Stack>
				</SheetBody>
			</Sheet>
		);
	}

	return (
		<Stack isVertical gutter="small">
			<StackItem isGrow className="card-body generte-order p-0">
				<Sheet isInset>
					<div className="generte-order-wrapper">
						<div className="generte-order-head">
							<Title level={4}>{getColumnAliasName('Order Info')}</Title>
							<Title level={5}>Enter all required order information and details to continue</Title>
						</div>
						<div className="generte-order-body">
							<Stack className="row-grid-3">
								<StackItem isStretch className="ant-form-group">
									<Stack isVertical>
										<StackItem isGrow>
											<Label isHighlight>
												{getColumnAliasName('Ship Date')} <sup>*</sup>{' '}
											</Label>
										</StackItem>
										<StackItem isGrow className="pt-0">
											<Stack gutter="small" isVertical>
												{data.useStoreSchedule ? (
													<StackItem isGrow isStretch>
														<Validation
															isTheme={true}
															{...query.isValid(
																'shipDateRange',
																data.shipDateRange,
																data
															)}
														>
															<DatePicker
																isRange={true}
																placeholder={['From Date', 'To Date']}
																name={'shipDateRange'}
																min={minShipStartDate}
																selectedDate={
																	data.shipDateRange
																		? [data.shipDateRange[0], data.shipDateRange[1]]
																		: null
																}
																handleClick={inputChangeHandler}
															/>
														</Validation>
													</StackItem>
												) : (
													<StackItem isStretch isGrow>
														<Validation
															isTheme={true}
															{...query.isValid(
																'shipStartDate',
																data.shipStartDate,
																data
															)}
														>
															<DatePicker
																placeholder="Select Ship Start Date"
																name={'shipStartDate'}
																min={minShipStartDate}
																selectedDate={data.shipStartDate}
																handleClick={inputChangeHandler}
															/>
														</Validation>
													</StackItem>
												)}
											</Stack>
										</StackItem>
									</Stack>
								</StackItem>
								<StackItem isStretch className="ant-form-group">
									<Stack isVertical align="top">
										<StackItem>
											<Label isHighlight>
												{' '}
												{getColumnAliasName('P.O. Date')} <sup>*</sup>{' '}
											</Label>
										</StackItem>
										<StackItem className="pt-0">
											<Validation isTheme={true} {...query.isValid('PODate', data.PODate)}>
												<DatePicker
													name={'PODate'}
													min={minShipStartDate}
													selectedDate={data.PODate}
													handleClick={inputChangeHandler}
													placeholder="Select PO Date"
												/>
											</Validation>
										</StackItem>
									</Stack>
								</StackItem>
								<StackItem isStretch className="ant-form-group">
									<Stack isVertical>
										<StackItem isGrow>
											<Label isHighlight>
												{getColumnAliasName('Customer')} <sup>*</sup>
											</Label>
										</StackItem>
										<StackItem isGrow className="pt-0">
											<OrderValidation
												isTheme={true}
												{...query.isValid('customerID', data.customerID)}
												isTouched={customerTouched}
											>
												<MultiSelectDropdown
													isMultiselect={true}
													placeholder={'Select Customer'}
													options={customerOptions}
													updateHandler={customerChangeHandler}
													selectedOption={data.customerID}
													onBlur={handleCustomerBlur}
												/>
											</OrderValidation>
										</StackItem>
									</Stack>
								</StackItem>
								<StackItem isStretch className="ant-form-group">
									<Stack isVertical>
										<StackItem>
											<Label isHighlight>
												{getColumnAliasName('Shipping Method')} <sup>*</sup>
											</Label>
										</StackItem>
										<StackItem className="pt-0">
											<Validation
												isTheme={true}
												{...query.isValid('shipMethodID', data.shipMethodID)}
											>
												<Dropdown
													placeholder={'Select Shipping Methods'}
													options={shippingMethodOptions}
													updateHandler={shipMethodChangeHandler}
													selectedOption={_.find(shippingMethodOptions, {
														value: data.shipMethodID,
													})}
												/>
											</Validation>
										</StackItem>
									</Stack>
								</StackItem>
								<StackItem isStretch className="ant-form-group">
									<Stack isVertical>
										<StackItem>
											<Label isHighlight>
												{getColumnAliasName('Warehouse')} <sup>*</sup>
											</Label>
										</StackItem>
										<StackItem className="pt-0">
											<Validation
												isTheme={true}
												{...query.isValid('warehouseID', data.warehouseID)}
											>
												<Dropdown
													placeholder={'Select Warehouse'}
													options={warehouseOptions}
													updateHandler={warehouseChangeHandler}
													selectedOption={_.find(warehouseOptions, {
														value: data.warehouseID,
													})}
												/>
											</Validation>
										</StackItem>
									</Stack>
								</StackItem>
								<StackItem isStretch className="ant-form-group">
									<Stack isVertical align="start">
										<StackItem>
											<Label isHighlight>{getColumnAliasName('Memo')} </Label>
										</StackItem>
										<StackItem align="center" className="pt-0">
											<Validation isTheme={true}>
												<TextInput
													name={'orderBatchMemo'}
													size="small"
													value={data.orderBatchMemo}
													onChange={inputChangeHandler}
												/>
											</Validation>
										</StackItem>
									</Stack>
								</StackItem>
								<StackItem isStretch className="ant-form-group">
									{data.useStoreSchedule && (
										<Stack isVertical>
											<StackItem isGrow>
												<Label isHighlight>{getColumnAliasName('Store Schedule')}</Label>
											</StackItem>
											<StackItem>
												<Validation
													isTheme={true}
													{...query.isValid('storeScheduleID', data.storeScheduleID, data)}
												>
													<Dropdown
														placeholder={'Select a Store Schedule'}
														options={storeScheduleOptions}
														updateHandler={storeScheduleChangeHandler}
														selectedOption={_.find(storeScheduleOptions, {
															value: data.storeScheduleID,
														})}
													/>
												</Validation>
											</StackItem>
										</Stack>
									)}
								</StackItem>
							</Stack>
						</div>
					</div>

					<SheetBody>
						<Stack isVertical gutter="medium">
							<StackItem className="ptb-24">
								<Divider></Divider>
							</StackItem>
							<StackItem>
								<Stack className="steps-checkbox-wrapper">
									<StackItem>
										<Stack gutter="small" className="steps-checkbox-block">
											<StackItem className="custom-checkbox">
												<input
													type={'checkbox'}
													onChange={inputChangeHandler}
													checked={data.useStoreSchedule}
													name={'useStoreSchedule'}
												/>
											</StackItem>
											<StackItem isGrow>
												<Label isHighlight>{getColumnAliasName('Use Store Schedule')}</Label>
											</StackItem>
										</Stack>
									</StackItem>
									<StackItem>
										<Stack gutter="small" className="steps-checkbox-block">
											<StackItem className="custom-checkbox">
												<input
													type={'checkbox'}
													onChange={inputChangeHandler}
													checked={data.useReserveInventory}
													name={'useReserveInventory'}
												/>
											</StackItem>
											<StackItem isGrow>
												<Label isHighlight>
													{getColumnAliasName('Show Reserve Inventory')}
												</Label>
											</StackItem>
										</Stack>
									</StackItem>
									<StackItem>
										<Stack gutter="small" className="steps-checkbox-block">
											<StackItem className="custom-checkbox">
												<input
													type={'checkbox'}
													onChange={inputChangeHandler}
													checked={data.isKitOrder}
													name={'isKitOrder'}
												/>
											</StackItem>
											<StackItem isGrow>
												<Label isHighlight>{getColumnAliasName('Use Kits')}</Label>
											</StackItem>
										</Stack>
									</StackItem>
									<StackItem>
										<Stack gutter="small" className="steps-checkbox-block">
											<StackItem className="custom-checkbox">
												<input
													type={'checkbox'}
													onChange={inputChangeHandler}
													checked={data.isPrimaryWarehouse}
													name={'isPrimaryWarehouse'}
												/>
											</StackItem>
											<StackItem isGrow>
												<Label isHighlight>{getColumnAliasName('Use Primary Warehouse')}</Label>
											</StackItem>
										</Stack>
									</StackItem>
									<StackItem>
										<Stack gutter="small" className="steps-checkbox-block">
											<StackItem className="custom-checkbox">
												<input
													type={'checkbox'}
													onChange={inputChangeHandler}
													checked={data.isZeroQty}
													name={'isZeroQty'}
												/>
											</StackItem>
											<StackItem isGrow>
												<Label isHighlight>{getColumnAliasName('Zero Quantity Order')}</Label>
											</StackItem>
										</Stack>
									</StackItem>
									<StackItem>
										<Stack gutter="small" className="steps-checkbox-block">
											<StackItem className="custom-checkbox">
												<input
													type={'checkbox'}
													onChange={inputChangeHandler}
													checked={data.hasParameters}
													name={'hasParameters'}
												/>
											</StackItem>
											<StackItem isGrow>
												<Label isHighlight>
													{getColumnAliasName('Show Parameter Settings')}
												</Label>
											</StackItem>
										</Stack>
									</StackItem>
									<StackItem>
										<Stack gutter="small" className="steps-checkbox-block">
											<StackItem className="custom-checkbox">
												<input
													type={'checkbox'}
													onChange={inputChangeHandler}
													checked={data.usePlanogram}
													name={'usePlanogram'}
												/>
											</StackItem>
											<StackItem isGrow>
												<Label isHighlight>{getColumnAliasName('Use Planogram')}</Label>
											</StackItem>
										</Stack>
									</StackItem>
								</Stack>
							</StackItem>
							{data.hasParameters && (
								<>
									<StackItem isStretch>
										<Divider />
									</StackItem>
									<StackItem>
										<Stack isVertical gutter="small">
											{_.uniqBy(parametersList, 'ParameterID').map((parameter) => {
												return (
													<StackItem key={parameter.ParameterID}>
														<ParameterDetailItem
															parameter={parameter}
															groupData={parametersList}
														></ParameterDetailItem>
													</StackItem>
												);
											})}
										</Stack>
									</StackItem>
								</>
							)}
							{data.usePlanogram && (
								<>
									<StackItem className="ptb-24">
										<Divider></Divider>
									</StackItem>
									<StackItem>
										<PlanogramDetails inputChangeHandler={inputChangeHandler}></PlanogramDetails>
									</StackItem>
								</>
							)}
						</Stack>
					</SheetBody>
				</Sheet>
			</StackItem>
			<StackItem isStretch>
				<Stack align="right" gutter="small" className="card-footer orderinfo-footer">
					<StackItem position="end">
						<Button
							isPrimary
							data-test-id="generate-order-select-stores"
							name={getColumnAliasName('Select Store')}
							disabled={validateFormData()}
							handleClick={handleNextClick}
						/>
					</StackItem>
				</Stack>
			</StackItem>
		</Stack>
	);
};

export default OrderInfo;
